// extracted by mini-css-extract-plugin
export default {"fade":"Modal_fade__IGSaw","modal":"Modal_modal__ObprG"};